export default __webpack_public_path__ + "static/media/cord-blood-1.b19a249d.jpg";